import { Expose, Type } from 'class-transformer';

import { SnOrganization, SnOrganizationSettings } from '@lib/api/entities';

export class PublicOrganization extends SnOrganization {
  @Expose()
  @Type(() => SnOrganizationSettings)
  public settings: SnOrganizationSettings;

  constructor(public readonly prefix: string) {
    super();
  }
}
